var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 100.8,
    height: 75.6,
    viewBox: "0 0 100.8 75.6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M42 43.05C50.6985 43.05 57.75 35.9985 57.75 27.3C57.75 18.6015 50.6985 11.55 42 11.55C33.3015 11.55 26.25 18.6015 26.25 27.3C26.25 35.9985 33.3015 43.05 42 43.05Z",
    fill: "url(#paint0_linear_0_29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M58.8 37.8C68.0784 37.8 75.6 30.2784 75.6 21C75.6 11.7216 68.0784 4.2 58.8 4.2C49.5216 4.2 42 11.7216 42 21C42 30.2784 49.5216 37.8 58.8 37.8Z",
    fill: "url(#paint1_linear_0_29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M74.55 44.1C82.6686 44.1 89.25 37.5186 89.25 29.4C89.25 21.2814 82.6686 14.7 74.55 14.7C66.4314 14.7 59.85 21.2814 59.85 29.4C59.85 37.5186 66.4314 44.1 74.55 44.1Z",
    fill: "url(#paint2_linear_0_29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M37.8 57.75C45.3387 57.75 51.45 51.6387 51.45 44.1C51.45 36.5613 45.3387 30.45 37.8 30.45C30.2613 30.45 24.15 36.5613 24.15 44.1C24.15 51.6387 30.2613 57.75 37.8 57.75Z",
    fill: "url(#paint3_linear_0_29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M54.6 58.8C63.8784 58.8 71.4 51.2784 71.4 42C71.4 32.7216 63.8784 25.2 54.6 25.2C45.3216 25.2 37.8 32.7216 37.8 42C37.8 51.2784 45.3216 58.8 54.6 58.8Z",
    fill: "url(#paint4_linear_0_29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M71.4 58.8C78.9387 58.8 85.05 52.6887 85.05 45.15C85.05 37.6113 78.9387 31.5 71.4 31.5C63.8613 31.5 57.75 37.6113 57.75 45.15C57.75 52.6887 63.8613 58.8 71.4 58.8Z",
    fill: "url(#paint5_linear_0_29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M81.9 49.35C87.1191 49.35 91.35 45.1191 91.35 39.9C91.35 34.6809 87.1191 30.45 81.9 30.45C76.6809 30.45 72.45 34.6809 72.45 39.9C72.45 45.1191 76.6809 49.35 81.9 49.35Z",
    fill: "url(#paint6_linear_0_29)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.7,
    d: "M58.8 6.3C52.5 21 63 31.5 54.6 58.8",
    stroke: "#F5F3FF",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.6,
    d: "M35.7 31.5C42 27.3 46.2 35.7 52.5 31.5M63 27.3C69.3 23.1 73.5 31.5 79.8 27.3M39.9 48.3C46.2 44.1 48.3 52.5 52.5 48.3M65.1 48.3C69.3 44.1 73.5 52.5 77.7 46.2",
    stroke: "#F5F3FF",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.18,
    d: "M56.7 72.45C69.4578 72.45 79.8 71.0397 79.8 69.3C79.8 67.5603 69.4578 66.15 56.7 66.15C43.9422 66.15 33.6 67.5603 33.6 69.3C33.6 71.0397 43.9422 72.45 56.7 72.45Z",
    fill: "#7C3AED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_29",
    x1: 26.25,
    y1: 11.55,
    x2: 57.75,
    y2: 43.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDD6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B5CF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_29",
    x1: 42,
    y1: 4.2,
    x2: 75.6,
    y2: 37.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDD6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B5CF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_29",
    x1: 59.85,
    y1: 14.7,
    x2: 89.25,
    y2: 44.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDD6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B5CF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_29",
    x1: 24.15,
    y1: 30.45,
    x2: 51.45,
    y2: 57.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDD6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B5CF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_29",
    x1: 37.8,
    y1: 25.2,
    x2: 71.4,
    y2: 58.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDD6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B5CF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_29",
    x1: 57.75,
    y1: 31.5,
    x2: 85.05,
    y2: 58.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDD6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B5CF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_29",
    x1: 72.45,
    y1: 30.45,
    x2: 91.35,
    y2: 49.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDD6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B5CF6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllAi);
export default __webpack_public_path__ + "static/media/ill-ai.00f95726b8a29ddc3bf0ad7c163f049e.svg";
export { ForwardRef as ReactComponent };